<ng-container ngForm (ngSubmit)="apply()" appPromptUnsubmitted>
    <td>
        <input type="text"
               name="collDate"
               class="form-control"
               [(ngModel)]="coll.date"
               [appIsInvalid]="!coll.date"
               [submitted]="wasSubmitted"
               [bsConfig]="{dateInputFormat: 'MM/YYYY', minMode: 'month'}"
               bsDatepicker
               readonly>
        <div class="invalid-feedback">
            Date is Required
        </div>
    </td>
    <td>
        <div class="autocomplete">
            <input
                name="collTitle"
                [(ngModel)]="coll.title"
                [appIsInvalid]="!coll.title"
                [submitted]="wasSubmitted"
                [typeahead]="titles$ | async"
                [typeaheadMinLength]="0"
                class="form-control">
            <div class="invalid-feedback">
                Title is Required
            </div>
        </div>
    </td>
    <td>
                    <textarea name="description"
                              autosize
                              [(ngModel)]="coll.description"
                              class="form-control"></textarea>
    </td>
    <td class="table-button">
        <ng-container *ngIf="!addNewMode; else newButtons">
            <div class="button-set">
                <a class="text-primary" (click)="apply()"><i class="icon-check"></i></a>
                <a class="text-danger" (click)="revert()"><i class="icon-close"></i></a>
            </div>
            <a class="edit"
               title="Upload photos" [routerLink]="[coll.id]"><i class="icon-picture"></i></a>
            <a *ngIf="currentUser?.permissions.canManagePlantingAreas" class="edit" title="Edit" (click)="edit()"><i class="icon-note"></i></a>
            <a *ngIf="currentUser?.permissions.canManagePlantingAreas" class="delete"
               (click)="onDelete.emit(coll)"
               title="Delete"><i class="icon-trash"></i></a>
        </ng-container>

        <ng-template #newButtons>
            <button type="submit" (click)="apply()" class="btn btn-primary">Add</button>
        </ng-template>
    </td>
</ng-container>
